export const SETUP_ROOT = "/setup"
export const SETTINGS_ROOT = "/settings"

export const isSetupPath = (pathname: string) =>
  pathname === SETUP_ROOT || pathname.startsWith(SETUP_ROOT + "/")

// Old Setup tab segment -> new Settings page segment. Every other segment is shared.
const SETUP_TO_SETTINGS_SEGMENT: Record<string, string> = {
  company: "general",
  returns: "demand",
  "purchase-orders": "procurement",
}

/** Maps a `/setup/...` href (path + optional search/hash) to its `/settings/...` equivalent. */
export function setupPathToSettings(href: string): string {
  if (!href.startsWith(SETUP_ROOT)) return href
  const rest = href.slice(SETUP_ROOT.length)
  if (rest !== "" && !/^[/?#]/.test(rest)) return href

  const match = /^\/([^/?#]+)(.*)$/.exec(rest)
  const segment = match?.[1]
  if (!match || !segment) return SETTINGS_ROOT + rest

  return `${SETTINGS_ROOT}/${SETUP_TO_SETTINGS_SEGMENT[segment] ?? segment}${match[2] ?? ""}`
}
